import { call, put, takeLatest } from 'redux-saga/effects';
import CommunicationTemplatesService from 'shared/services/CommunicationTemplates';
import {
  getCommunicationTemplates,
  setCommunicationTemplates,
  failAction
} from './communicationTemplates.redux';
import { ICommunicationTemplate } from 'shared/interfaces/communicationTemplate.interface';

function* getCommunicationTemplatesSaga() {
  try {
    const result: ICommunicationTemplate[] = yield call(
      CommunicationTemplatesService.getAllCommunicationTemplates
    );

    yield put(setCommunicationTemplates(result));
  } catch (error) {
    console.log('getCommunicationTemplatesSaga error:', error);
    yield put(failAction());
  }
}

function* CommunicationTemplates() {
  yield takeLatest(
    getCommunicationTemplates.type,
    getCommunicationTemplatesSaga
  );
}

export default CommunicationTemplates;
